const DashLayout = () => import('@/layouts/DashLayout.vue')
import Guard from '@/services/middleware'

// dashboard
const DashReports = () => import('@/views/dash/reports/HomeReports.vue')
//atendimentos

const AttendanceReportsHome = () => import('@/views/dash/reports/page/calls/OverviewAttendance.vue')
const AttendanceReportsTag = () => import('@/views/dash/reports/page/calls/ClassificationAttendance.vue')
const AttendanceReportsDepartment = () => import('@/views/dash/reports/page/calls/DepartmentsAttendance.vue')
const CallsTotalizerMount = () => import('@/views/dash/reports/page/calls/TotalizerMount.vue')

const SATISFACTION_MODULES = ['mod_report', 'mod_report_satisfaction_own']

// mod_report
export default [
    {
        path: '/relatorios',
        component: DashLayout,
        beforeEnter: [
            Guard.redirectIfNotAuthenticated,
            Guard.guardReportsOwnMode,
            Guard.checkModuleAccess,
        ],
        children: [
            {
                path: '',
                name: 'reports.home',
                component: DashReports,
                meta: { title: 'Relatórios', permission: 2, module: SATISFACTION_MODULES },
                beforeEnter: Guard.guardReportsOwnMode,
            },
            {
                path: 'atendimentos',
                name: 'reports.attendance',
                component: () => import('@/views/dash/reports/CallsReports.vue'),
                meta: { title: 'Atendimentos', permission: 2, module: 'mod_report' },
                beforeEnter: Guard.guardReportsOwnMode,
                children: [
                    {
                        path: '',
                        name: 'reports.attendance.index',
                        component: AttendanceReportsHome,
                        meta: { permission: 2 , module: 'mod_report' },
                    },
                    {
                        path: 'andamento',
                        name: 'reports.attendance.progress',
                        component: AttendanceReportsHome,
                        meta: { permission: 2,  module: 'mod_report' },
                    },
                    {
                        path: 'espera',
                        name: 'reports.attendance.wait',
                        component: AttendanceReportsHome,
                        meta: { permission: 2,  module: 'mod_report' },
                    },
                    {
                        path: 'automacao',
                        name: 'reports.attendance.automation',
                        component: AttendanceReportsHome,
                        meta: { permission: 2,  module: 'mod_report' },
                    },
                    {
                        path: 'encerrados',
                        name: 'reports.attendance.closed',
                        component: AttendanceReportsHome,
                        meta: { permission: 2,  module: 'mod_report' },
                    },
                    {
                        path: 'classificacao-de-atendimento',
                        name: 'reports.attendance.tag',
                        component: AttendanceReportsTag,
                        meta: { permission: 2,  module: 'mod_report' },
                    },
                    {
                        path: 'departamentos',
                        name: 'reports.attendance.department',
                        component: AttendanceReportsDepartment,
                        meta: { permission: 2,  module: 'mod_report' },
                    },
                    {
                        path: 'total-mensal',
                        name: 'reports.calls.totalizerMount',
                        component: CallsTotalizerMount,
                        meta: { permission: 2,  module: 'mod_report' },
                    },
                    {
                        path: 'nao-atribuidos',
                        name: 'reports.calls.unassigned',
                        component: AttendanceReportsHome,
                        meta: { permission: 2,  module: 'mod_report' },
                    },

                ],
            },
            {
                path: 'atendentes',
                name: 'reports.attendants',
                component: () => import('@/views/dash/reports/AttendantsReports.vue'),
                meta: { title: 'Atendentes', permission: 2, module: 'mod_report' },
                beforeEnter: Guard.guardReportsOwnMode,
                children: [
                    {
                        path: '',
                        name: 'reports.attendants.overview',
                        component: () => import('@/views/dash/reports/page/attendants/OverviewAttendance.vue'),
                        meta: { permission: 2, module: 'mod_report' },
                    },
                    {
                        path: '',
                        name: 'reports.attendants.v2.overview',
                        component: () => import('@/views/dash/reports/page/attendants/OverviewV2Attendant.vue'),
                        meta: { permission: 2, module: 'mod_report' },
                    },
                    {
                        path: 'canais',
                        name: 'reports.attendants.channels',
                        component: () => import('@/views/dash/reports/page/attendants/ChannelsAttendance.vue'),
                        meta: { permission: 2, module: 'mod_report' },
                    },
                    {
                        path: 'transferencia',
                        name: 'reports.attendants.transfer',
                        component: () => import('@/views/dash/reports/page/attendants/TransferAttendance.vue'),
                        meta: { permission: 2,  module: 'mod_report' },
                    },
                    {
                        name: 'reports.attendants.status',
                        path: 'status',
                        component: () => import('@/views/dash/reports/page/attendants/StatusAttendance.vue'),
                        meta: { permission: 2,  module: 'mod_report' }
                    },
                    {
                        name: 'reports.attendants.authentication',
                        path: 'autenticacao',
                        component: () => import('@/views/dash/reports/page/attendants/AuthenticationAttendance.vue'),
                        meta: { permission: 2,  module: 'mod_report' }
                    }
                ],
            },
            {
                path: 'canais',
                name: 'reports.channels',
                component: () => import('@/views/dash/reports/ChannelsReports.vue'),
                meta: { title: 'Canais', permission: 2, module: 'mod_report' },
                beforeEnter: Guard.guardReportsOwnMode,
                children: [
                    {
                        path: '',
                        name: 'reports.channel.home',
                        component: () => import('@/views/dash/reports/page/channels/OverviewChannels.vue'),
                        meta: { permission: 2 },
                    },
                    {
                        path: 'disparo',
                        name: 'reports.channel.disparo',
                        component: () => import('@/views/dash/reports/page/channels/OverviewDisparo.vue'),
                        meta: { permission: 2 },
                    },
                ],
            },
            {
                path: 'clientes',
                name: 'reports.clients',
                component: () => import('@/views/dash/reports/ClientsReports.vue'),
                meta: { title: 'Clientes', permission: 2, module: 'mod_report' },
                beforeEnter: Guard.guardReportsOwnMode,
                children: [
                    // {
                    //     path: 'remove_client',
                    //     name: 'reports.clients.list',
                    //     component: () => import('@/views/dash/reports/page/clients/MyClients.vue'),
                    //     meta: { title: 'Meus clientes', permission: 2, module: 'mod_report' },
                    // },
                    {
                        path: '',
                        name: 'reports.clients.home',
                        component: () => import('@/views/dash/reports/page/clients/HomeClients.vue'),
                        meta: { title: 'Totais de atendimentos por clientes', permission: 2, module: 'mod_report' },
                    },
                ],
            },
            {
                path: 'ligacoes',
                name: 'reports.telephonyCalls',
                component: () => import('@/views/dash/reports/TelephonyCallsReports.vue'),
                meta: { title: 'Ligações', permission: 2, module: 'mod_report' },
                beforeEnter: Guard.guardReportsOwnMode,
                children: [
                    {
                        path: '',
                        name: 'reports.telephonyCalls.home',
                        component: () => import('@/views/dash/reports/page/telephony/OverviewCalls.vue'),
                        meta: { permission: 2, module: 'mod_report' },
                    },
                ],
            },
            {
                path: 'mensagens-por-atendente',
                name: 'reports.userMessages',
                component: () => import('@/views/dash/reports/page/messages/UserMessagesStatistics.vue'),
                meta: { title: 'Mensagens por atendente', permission: 2, module: 'mod_report' },
                beforeEnter: Guard.guardReportsOwnMode,
            },
            {
                path: 'anuncios',
                name: 'reports.referrals',
                component: () => import('@/views/dash/reports/page/referrals/OverviewReferrals.vue'),
                meta: { title: 'Anúncios (Referrals)', permission: 2, module: 'mod_report' },
                beforeEnter: Guard.guardReportsOwnMode,
            },
            {
                path: 'pesquisa-de-satisfacao',
                name: 'reports.satisfactionSurvey',
                component: () => import('@/views/dash/reports/SatisfactionSurveyReports.vue'),
                meta: { title: 'Clientes', permission: 2, module: SATISFACTION_MODULES },
                children: [
                    {
                        path: '',
                        name: 'reports.satisfactionSurvey.home',
                        component: () => import('@/views/dash/reports/page/satisfaction/DashSatisfactionSurvey.vue'),
                        meta: { title: 'Dashboard da pesquisa de satisfação', permission: 2, module: SATISFACTION_MODULES },
                    },
                    {
                        path: 'atendentes',
                        name: 'reports.satisfactionSurvey.attendants',
                        component: () => import('@/views/dash/reports/page/satisfaction/AttendantsSatisfactionSurvey.vue'),
                        meta: { title: 'Atendentes da pesquisa de satisfação', permission: 2, module: SATISFACTION_MODULES },
                    },
                    {
                        path: 'respostas',
                        name: 'reports.satisfactionSurvey.reply',
                        component: () => import('@/views/dash/reports/page/satisfaction/ReplySatisfactionSurvey.vue'),
                        meta: { title: 'Respostas da pesquisa de satisfação', permission: 2, module: SATISFACTION_MODULES },
                    },
                    {
                        path: 'respostas-automacao',
                        name: 'reports.satisfactionSurvey.automationReply',
                        component: () => import('@/views/dash/reports/page/satisfaction/AutomationReplySatisfactionSurvey.vue'),
                        meta: { title: 'Respostas (Automação) da pesquisa de satisfação', permission: 2, module: SATISFACTION_MODULES },
                    },
                    {
                        path: 'classificacao',
                        name: 'reports.satisfactionSurvey.classification',
                        component: () => import('@/views/dash/reports/page/satisfaction/ClassificationAttendances.vue'),
                        meta: { title: 'Classificação da pesquisa de satisfação', permission: 2, module: SATISFACTION_MODULES },
                    },
                    {
                        path: ':id(\\d+)',
                        name: 'reports.satisfactionSurvey.dashboard',
                        component: () => import('@/views/dash/reports/page/satisfaction/SurveyDashboard.vue'),
                        meta: { title: 'Dashboard da pesquisa de satisfação', permission: 2, module: SATISFACTION_MODULES },
                    },

                ],
            },
            {
                path: 'crm',
                name: 'reports.crm',
                component: () => import('@/views/dash/reports/CRMReports.vue'),
                meta: { title: 'CRM', permission: 2, module: 'mod_report' },
                beforeEnter: Guard.guardReportsOwnMode,
                children: [
                    {
                        path: '',
                        name: 'reports.crm.dashboard',
                        component: () => import('@/views/dash/reports/page/crm/DashboardCRMReports.vue'),
                        meta: { permission: 2, module: 'mod_report' },
                    },
                    {
                        path: 'vendedores',
                        name: 'reports.crm.sellers',
                        component: () => import('@/views/dash/reports/page/crm/SellersCRMReports.vue'),
                        meta: { permission: 2, module: 'mod_report' },
                    },
                    {
                        path: 'receita',
                        name: 'reports.crm.revenue',
                        component: () => import('@/views/dash/reports/page/crm/RevenueCRMReports.vue'),
                        meta: { permission: 2, module: 'mod_report' },
                    },
                    {
                        path: 'tarefas',
                        name: 'reports.crm.tasks',
                        component: () => import('@/views/dash/reports/page/crm/TasksCRMReports.vue'),
                        meta: { permission: 2, module: 'mod_report' },
                    },
                ],
            },
            // {
            //     path: '/reports/aiagents',
            //     name: 'reports.aiagents',
            //     component: () => import('@/views/dash/reports/AIAgentsReports.vue'),
            //     children: [
            //         {
            //         path: '',
            //         name: 'reports.aiagents.home',
            //         component: () => import('@/views/dash/reports/page/aiagents/OverviewAIAgents.vue'),
            //         },
            //     ],
            // },
        ],
    },
]
